module.exports = __webpack_public_path__ + "static/img/dy2-5.61b75d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy2-5.png
// module id = 958
// module chunks = 0